<template>
  <div class="ti-dealer-locator" ref="dealerLocator"></div>
</template>

<script lang="ts" setup>
import { Dealer } from '@owc/connection-wko-manager';
import { onMounted, Ref, ref } from 'vue';
import setup from '../../composables/setup';

const { configurationId, applicationInfos } = setup();
const loading = ref(true);
const tradeinAppElement: Ref<Element> = ref({} as Element);
const dealerLocator: Ref<HTMLElement> = ref(null as any as HTMLElement);
const emit = defineEmits(['selectedDealer']);

onMounted(() => {
  if (applicationInfos.value && applicationInfos.value.dlc) {
    tradeinAppElement.value = document.getElementsByTagName('tradein-app')[0];

    Promise.all([
      loadSript(applicationInfos.value.dlc.jsUrl, 'script'),
      loadSript(applicationInfos.value.dlc.cssUrl, 'link'),
    ]).then(() => {
      loading.value = false;
      const dsw = new DealerLocator({
        applicationId: 'TI',
        configId: applicationInfos.value.dlc.configId,
        market:
          applicationInfos.value.dlc.configurationId[configurationId.value]
            .market,
        language:
          applicationInfos.value.dlc.configurationId[configurationId.value]
            .language,
        element: dealerLocator.value,
        searchProfileName:
          applicationInfos.value.dlc.configurationId[configurationId.value]
            .searchProfileName,
        apiKey: applicationInfos.value.dlc.apiKey,
        selectDealerCallback: (dealer: Dealer) =>
          emit('selectedDealer', dealer),
      });

      dsw.init();
    });
  }
});

const loadSript = (src: string, type: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const element = document.createElement(type);
    if (type === 'script') {
      element.setAttribute('src', src);
    } else if (type === 'link') {
      element.setAttribute('rel', 'stylesheet');
      element.setAttribute('href', src);
    } else {
      reject('wrongType');
    }
    if (tradeinAppElement.value?.shadowRoot) {
      tradeinAppElement.value?.shadowRoot.appendChild(element);
    } else {
      document.head.appendChild(element);
    }
    element.onload = () => {
      resolve(src);
    };
    element.onerror = () => {
      reject('loadingError');
    };
  });
};
</script>

<style lang="scss" src="./dealer-locator.scss"></style>
